import { ColumnTogglerButton, DownloadButton } from "_components/buttons";
import SearchInput from "_components/SearchInput";
import { CustomTable } from "_components/table/CustomTable";
import { eventsActions, vehicleActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export { DataTableBusOffLine}

function DataTableBusOffLine () {

    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const events = useSelector(state => state.events);

    const handleViewBus = (item) => {
        dispatch(vehicleActions.setVehicle(item));
        navigate(`bus/${item.HEADER_VIN}`)
    }

    useEffect(() => {
        dispatch(eventsActions.getOffline());
    }, [])

    useEffect(() => {
        if (events?.offline) {
            setData(events.offline);
            setFilteredData(events.offline);
        }
    }, [events]);

    const headers = [
        { label: 'Flotte', key: 'METROPOLIS', type: 'string', canToggle: false, visible: true},
        { label: 'Parc', key: 'PARK_NUMBER', type: 'string', canToggle: false, visible: true },
        { label: 'VIN', key: 'HEADER_VIN', type: 'string', canToggle: false, visible: true },
        { label: 'Pays', key: 'COUNTRY', type: 'string', canToggle: true, visible: false },
        { label: 'Odomètre', key: 'DST', type: 'string', canToggle: true, visible: true },
        { label: 'Hors ligne depuis (heures)', key: 'OFFLINE_SINCE', type: 'string', canToggle: false, visible: true },
        { label: '', key: 'bus_info', type: 'action', action: handleViewBus, icon: 'viewBus', canToggle: false, visible: true, title: 'Voir le détail du bus'},
    ]

    /**Gestion de l'état d'affichage de la div de sélection de colonnes */
    const [visibleColumns, setVisibleColumns] = useState(
        headers.map(header => ({ ...header, visible: header.visible }))
    );    

    const toggleColumnVisibility = (index) => {
        const newColumns = [...visibleColumns];
        newColumns[index].visible = !newColumns[index].visible;
        setVisibleColumns(newColumns);
    };     
    
    // Fonction pour mettre à jour les données filtrées
    const handleFilteredData = (newFilteredData) => {
        if (JSON.stringify(newFilteredData) !== JSON.stringify(filteredData)) {
            setFilteredData(newFilteredData);
        }
    };
    

    return (
        <div className="custom-table-container mt-4">
            <div className={'flex justify-between items-center'}>
                <div>
                    <span className={'title-customtable'}>{filteredData.length}</span>
                    <span className={'small-title-customtable'}>  Bus Offline </span>
                </div>
                <div className="flex gap-6">
                    <SearchInput data={data} onFilteredData={handleFilteredData} />
                    <DownloadButton title={`Bus Offline`} headers={headers} data={filteredData} />
                    <ColumnTogglerButton
                        visibleColumns={visibleColumns}
                        toggleColumnVisibility={toggleColumnVisibility}
                    />
                </div>
            </div>
            <div className={"my-4 "}>
                <CustomTable data={filteredData} headers={visibleColumns} />
            </div>
        </div>
    )
}